import {BaseController} from "../../../../../infrastructure/controllers/base-controller";

import {BreadcrumbsPopulateHandler} from "../../../../../core/handlers/breadcrumbs-populate.handler";
import type {GameCenterContainerState} from "../../../models/game-center-container.state";
import {NEW_GAME_CENTER_CONTAINER} from "../../../game-center-container.consts";

export class GameCenterIndexPageBreadcrumbsHandler extends BreadcrumbsPopulateHandler {
  type = NEW_GAME_CENTER_CONTAINER.ACTION_TYPES.breadcrumbsHandler;
  state: GameCenterContainerState;

  action(params) {
    this.websiteModel.entitiesContext.game && this.createBreadcrumbs(params.entity);

    this.websiteModel.entitiesContext.registerToGameExist(GameCenterIndexPageBreadcrumbsHandler.name, () => this._handleEntityChange(params.entity));
  }

  createBreadcrumbs(entity) {
    super.createBreadcrumbs(entity.sport.name);

    const matchName: String = `${entity?.homeCompetitor?.name} ${this.terms.GAME_TITLE_VS} ${entity?.awayCompetitor?.name}`;

    this.addGameCompetitionBreadcrumbs(entity);
    this.addGameBreadcrumbs(matchName);
  }

  onUnloaded(controller: BaseController) {
    super.onUnloaded(controller);

    this.cleanBreadcrumbs();
    this.websiteModel.entitiesContext.removeGameCallback(GameCenterIndexPageBreadcrumbsHandler.name);
  }
}
